const CANCELED_CARDS_MARKER = 'cartões estão cancelados'

export function parseCanceledCardsMessage(message: string): {
  intro: string
  proxies: string[]
} | null {
  if (typeof message !== 'string' || !message.trim()) return null

  const markerIndex = message
    .toLocaleLowerCase('pt-BR')
    .indexOf(CANCELED_CARDS_MARKER.toLocaleLowerCase('pt-BR'))

  if (markerIndex === -1) return null

  const afterMarker = message.slice(markerIndex + CANCELED_CARDS_MARKER.length)
  const colonIndex = afterMarker.indexOf(':')
  if (colonIndex === -1) return null

  const proxies = afterMarker
    .slice(colonIndex + 1)
    .split(',')
    .map((proxy) => proxy.trim())
    .filter(Boolean)

  if (!proxies.length) return null

  return {
    intro: `${message
      .slice(0, markerIndex + CANCELED_CARDS_MARKER.length)
      .trim()}:`,
    proxies,
  }
}
